import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import classNames from 'classnames';
import icons from './icons';

import styles from './styles';

const ADGMCheckbox = ({
  classes,
  label,
  checked,
  indeterminateChecked,
  disabled,
  onChangeHandler,
  customClasses,
  ...otherProps
}) => {
  return (
    <FormControlLabel
      className={classNames(classes.inputFormControl, customClasses?.inputFormControl)}
      onChange={onChangeHandler}
      // label={intl.formatMessage({ ...messages.select_all })}
      label={label}
      {...otherProps}
      control={
        <Checkbox
          edge='start'
          checked={checked}
          indeterminate={indeterminateChecked}
          icon={icons.icon}
          indeterminateIcon={icons.indeterminateIcon}
          checkedIcon={icons.checkedIcon}
          classes={{
            root: classNames(classes.checkboxRoot, customClasses?.checkboxRoot),
            checked: classNames(classes.checkboxChecked, customClasses?.checkboxChecked),
            indeterminate: classNames(classes.checkboxIntermediate, customClasses?.checkboxIntermediate),
          }}
          disabled={disabled}
        />
      }
    />
  );
};

ADGMCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  indeterminateChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChangeHandler: PropTypes.func.isRequired,
  customClasses: PropTypes.object,
};

ADGMCheckbox.defaultProps = {
  indeterminateChecked: false,
  disabled: false,
  customClasses: {},
};

export default withStyles(styles)(ADGMCheckbox);
